import { render, staticRenderFns } from "./OwnerShare.vue?vue&type=template&id=573c1b5e&scoped=true"
import script from "./OwnerShare.vue?vue&type=script&lang=js"
export * from "./OwnerShare.vue?vue&type=script&lang=js"
import style0 from "./OwnerShare.vue?vue&type=style&index=0&id=573c1b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573c1b5e",
  null
  
)

export default component.exports